import React, { useEffect, useMemo, useState } from "react";
import { Flex } from "./style";
import MessageCard from "../../../components/Cards/ContactCard";
import Pagination from "../../../components/FormElement/Pagination";
import { useShowModal, useHideModal } from "../../../hooks";
import Tabs from "../../../components/Tab";
import service from "../../../services/contactMessage";
import Spinner from "../../../components/Spinner/FullScreen";
import DeleteModal from "../../../components/Achive";
import { useShowAlert } from "../../../hooks/useAlerts";

function ContactMessage() {
  const [selectedCategory, setSelectedCategory] = useState("1");
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);

  const categoryQuery = useMemo(
    () => (selectedCategory ? `&status=${selectedCategory}` : ""),
    [selectedCategory]
  );
  const pageQuery = useMemo(
    () => (pagination.page ? `page=${pagination.page}` : " "),
    [pagination.page]
  );
  const limitQuery = useMemo(
    () => (pagination.limit ? `&limit=${pagination.limit}` : ""),
    [pagination.limit]
  );
  const query = useMemo(
    () => `${pageQuery}${limitQuery}${categoryQuery}`,
    [pageQuery, limitQuery, categoryQuery]
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await service.getAllPaginate(query);
      const finalResult = result?.rows?.map((item) => ({
        ...item,
        title: item?.full_name,
      }));
      setData(finalResult);
      setTotal(result?.count);
    } catch (err) {
      console.log(err);
      error(
        "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [query]);

  const options = useMemo(
    () => [
      { key: "1", label: "Yangi" },
      { key: "2", label: "Arxiv" },
    ],
    [selectedCategory]
  );

  const changeTab = (key) => {
    setPagination((prev) => ({ ...prev, page: 1 }));
    setSelectedCategory(key);
  };
  const handleChangePagination = (pageNumber) => {
    setPagination((prev) => ({ ...prev, page: pageNumber }));
  };
  const handleDelete = (id) => {
    if (id) {
      showBlured({
        title: "",
        maxWidth: "400px",
        maxHeight: "500px",
        withHeader: false,
        body: () => <DeleteModal onClick={() => handleDel(id)} />,
      });
    }
  };
  const handleDel = (id) => {
    setLoading(true);
    service
      .achive(id)
      .then(() => {
        fetchData();
        hideModal();
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (loading) return <Spinner />;
  return (
    <div>
      <Tabs
        tabs={options}
        defaultCurrent={selectedCategory}
        onChange={(key) => changeTab(key)}
      />
      <Flex>
        {data.map((item, i) => (
          <MessageCard
            key={i}
            data={item}
            onAchive={handleDelete}
            noaction={selectedCategory == "1" ? false : true}
          />
        ))}
      </Flex>
      {total > 10 && (
        <Pagination
          total={total}
          onChange={handleChangePagination}
          defaultPageSize={pagination.limit}
          defaultCurrent={pagination.page}
        />
      )}
    </div>
  );
}

export default ContactMessage;
